<template lang="pug">
div.w-full.flex-1.overflow-auto.p-4
  //- User object
  UserInspect(v-if="isUserObject" :data="data")
  
  //- Payment record - use PaymentDetails component
  PaymentDetails(v-else-if="isPaymentRecord" :data="data" :showRawJson="true" :hideCardVisual="true")
  
  //- Service object
  ServiceInspect(v-else-if="isServiceObject" :data="data")
  
  //- Emoji formatted object
  EmojiFormattedInspect(v-else-if="hasEmojiFormatting" :data="data")
  
  //- Default fallback
  DefaultInspect(v-else :data="data")
</template>

<script lang="ts" setup>
import UserInspect from './inspect/UserInspect.vue'
import ServiceInspect from './inspect/ServiceInspect.vue'
import EmojiFormattedInspect from './inspect/EmojiFormattedInspect.vue'
import DefaultInspect from './inspect/DefaultInspect.vue'
import PaymentDetails from './PaymentDetails.vue'

const props = defineProps<{
  data: any
}>()

// Check if this is a user object
const isUserObject = computed(() => {
  const obj = props.data
  return obj && 
    'id' in obj && 
    'email' in obj && 
    'reg_ip' in obj
})

// Check if this is a payment record
const isPaymentRecord = computed(() => {
  const obj = props.data
  return obj && (
    obj.payment_id || 
    obj.pi_id || 
    obj.session_id || 
    obj.capture_id || 
    obj.order_id || 
    obj.pmw_ref || 
    obj.trade_id ||
    (obj.channel && obj.total_fee !== undefined) ||
    (obj.extra && typeof obj.extra === 'object' && obj.channel)
  )
})

// Check if this is a service object
const isServiceObject = computed(() => {
  const obj = props.data
  return obj && 
    'user_id' in obj &&
    'cate' in obj &&
    ('status' in obj || 'quote' in obj || 'used' in obj)
})

// Check if object has emoji formatting
const hasEmojiFormatting = computed(() => {
  const obj = props.data
  return obj && 
    typeof obj === 'object' && 
    Object.keys(obj).some(key => /[💳🌍🔒📊👤💰]/u.test(key))
})
</script>
